function ChangeDateConfirmationRelevantFiles({ data }) {
  const makeReadableName = (path) => {
    if (!path) return "";
    let name = decodeURIComponent(path.split("/").pop());

    name = name.replace(/-\d+\.(pdf|docx|txt|csv|png|jpg)$/i, ".$1");

    name = name.replace(/(\.[a-z0-9]+)\1$/i, "$1");

    name = name.replace(/[_-]+/g, " ");

    name = name.charAt(0).toUpperCase() + name.slice(1);

    return name;
  };

  if (data?.relatedDocs?.length === 0) return <></>;

  return (
    <div className="w-full bg-white rounded-xl border border-gray-200 p-5 mt-4">
      <span className="block font-semibold text-gray-900 text-base mb-2">
        Uploaded Files
      </span>
      {/* Header */}
      {data?.relatedDocs?.length ? (
        data?.relatedDocs?.map((doc, docIndex) => (
          <a
            key={docIndex}
            href={doc}
            className="text-primary1 hover:underline font-medium"
          >
            {makeReadableName(doc)}
          </a>
        ))
      ) : (
        <div className="font-medium text-gray-400">None</div>
      )}
    </div>
  );
}

export default ChangeDateConfirmationRelevantFiles;
